module.exports = __webpack_public_path__ + "components/resort-webcams/static/spinner-f48b3892f2f525761d8b7c5d5b16f167.gif";